import {UseQueryResult, useQuery} from 'react-query';

import {ApiFeature, batchFetchFeatures} from 'src/lib/api/project';

export function useFeatures(
  featureIds: ApiFeature['id'][],
  options: {enabled?: boolean} = {}
): UseQueryResult<ApiFeature[]> {
  return useQuery(
    ['features', {featureIds}],
    () => {
      return batchFetchFeatures(featureIds);
    },
    {enabled: options.enabled ?? true}
  );
}
